import { type AllowedOrgType, ANY_ORG, PURCHASER_ONLY, SUPPLIER_ONLY } from './permissions';

interface RoutePermission {
  allowedOrgTypes?: AllowedOrgType[];
}

/**
 * Maps route patterns to permission requirements.
 * Patterns use react-router path syntax (e.g. /parts/:id).
 * Routes not listed here are unrestricted.
 */
export const ROUTE_PERMISSIONS: Record<string, RoutePermission> = {
  '/': ANY_ORG,
  '/storefront': SUPPLIER_ONLY,
  '/parts': ANY_ORG,
  '/parts/import': ANY_ORG,
  '/parts/:id': ANY_ORG,
  '/orders': ANY_ORG,
  '/orders/management/:id': SUPPLIER_ONLY,
  '/orders/:id': PURCHASER_ONLY,
  '/rfqs': ANY_ORG,
  // Order matters: the first matching pattern wins, and '/rfqs/:id' also
  // matches '/rfqs/new-rfq', so the more specific route has to come first.
  '/rfqs/new-rfq': PURCHASER_ONLY,
  '/rfqs/:id': ANY_ORG,
  '/messages': ANY_ORG,
  '/settings': ANY_ORG,
  '/membership': SUPPLIER_ONLY,
};
